import { render, staticRenderFns } from "./BtnEditRates.vue?vue&type=template&id=5a9987ec&scoped=true"
import script from "./btnEditRates.ts?vue&type=script&lang=ts&external"
export * from "./btnEditRates.ts?vue&type=script&lang=ts&external"
import style0 from "./BtnEditRates.vue?vue&type=style&index=0&id=5a9987ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9987ec",
  null
  
)

export default component.exports